package com.sweetlime.dungeonamigo.api

import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get

class Open5eApi(private val client: HttpClient) {

    private companion object {
        const val BASE = "https://api.open5e.com/v1"
    }

    suspend fun fetchSpells(url: String = "$BASE/spells/?limit=100"): Open5eListResponse<SpellDto> =
        client.get(url).body()

    suspend fun fetchMonsters(url: String = "$BASE/monsters/?limit=100"): Open5eListResponse<MonsterDto> =
        client.get(url).body()

    suspend fun fetchMagicItems(url: String = "$BASE/magicitems/?limit=100"): Open5eListResponse<MagicItemDto> =
        client.get(url).body()

    suspend fun fetchWeapons(url: String = "$BASE/weapons/?limit=100"): Open5eListResponse<WeaponDto> =
        client.get(url).body()

    suspend fun fetchBackgrounds(url: String = "$BASE/backgrounds/?limit=100"): Open5eListResponse<BackgroundDto> =
        client.get(url).body()

    suspend fun fetchClasses(url: String = "$BASE/classes/?limit=100"): Open5eListResponse<ClassDto> =
        client.get(url).body()

    suspend fun fetchRaces(url: String = "$BASE/races/?limit=100"): Open5eListResponse<RaceDto> =
        client.get(url).body()
}